let init = false;
function swiperCard() {
  if (window.innerWidth <= 1024) {
    if (!init) {
      init = true;
        const swiper2 = new MinimogLibs.Swiper('.swiper-t4e', {
                        // Optional parameters
                        direction: 'horizontal',
                        loop: false,
                         slidesPerView: 3,
           // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },
                      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
